<template>
	<!--代码部分begin-->
		<div id="floatTools" class="rides-cs" style="height:207px;">
			<div class="floatL">
				<a id="aFloatTools_Show" class="btnOpen" title="查看在线客服" style="top: 20px; display: none;" href="javascript:void(0);">展开</a>
				<a id="aFloatTools_Hide" class="btnCtn" title="关闭在线客服" style="top: 20px;" href="javascript:void(0);">收缩</a>
			</div>
			<div id="divFloatToolsView" class="floatR" style="height: 237px; width: 140px;">
				<div class="cn">
					<h3 class="titZx">在线客服</h3>
					<ul>
						<li><span>问题咨询</span>
							<!--<a target="_blank" href="http://wpa.qq.com/msgrd?v=3&uin=615749774&site=oicqzone.com&menu=yes">-->                                                    
							<a target="_blank" href="tencent://message/?uin=615749774&site=oicqzone.com&menu=yes">
							<img  :src="qq_img" alt="点击这里给我发消息" title="点击这里给我发消息"></img></a>
						</li>
						<li><span>企业会员</span>
							<a  href="tencent://message/?uin=615749774&site=qq&menu=yes">
							<img border="0" :src="qq_img" alt="点击这里给我发消息" title="点击这里给我发消息"></img></a>
						</li>
						<!--<li><span>加入群</span>
							http://wpa.qq.com/msgrd?v=3&uin=QQ号码&site=qq&menu=yes
							"http://wpa.qq.com/msgrd?v=3&uin=381232999&site=oicqzone.com&menu=yes";
                            "mqqwpa://im/chat?chat_type=wpa&uin=381232999&version=1&src_type=web&web_src=oicqzone.com";

							<a target="_blank" href="https://qm.qq.com/cgi-bin/qm/qr?k=X23pWeBFiKmA6LujMjVED8y1-syne6dk&amp;jump_from=webapi">
								<img border="0" :src="qq_img2" alt="点击这里给我发消息 " title="点击这里给我发消息 "></img></a>
						</li>-->

						<li>
							<a href=" " target="_blank ">沈阳驰冠科技有限公司</a>
							<div class="div_clear "></div>
						</li>
						<li style="border:none; "><span>电话：13604018403</span> </li>
					</ul>
				</div>
			</div>
		</div>
</template>

<script>
	export default{
		data(){
			return {
				'qq_img':require('../assets/img/source/counseling_style_52.png'),
				'qq_img2':require('../assets/img/source/group.png'),
			}
		}
	}
	$(function() {
		$("#aFloatTools_Show ").click(function() {
			$('#divFloatToolsView').animate({
				width: 'show',
				opacity: 'show'
			}, 100, function() {
				$('#divFloatToolsView').show();
			});
			$('#aFloatTools_Show').hide();
			$('#aFloatTools_Hide').show();
		});
		$("#aFloatTools_Hide ").click(function() {
			$('#divFloatToolsView').animate({
				width: 'hide',
				opacity: 'hide'
			}, 100, function() {
				$('#divFloatToolsView').hide();
			});
			$('#aFloatTools_Show').show();
			$('#aFloatTools_Hide').hide();
		});
		
		$('#divFloatToolsView').hide();
		$('#aFloatTools_Show').show();
		$('#aFloatTools_Hide').hide();

	});
</script>

<style>
	* {
		margin: 0;
		padding: 0;
		list-style: none;
	}
	
	img {
		border: 0;
	}
	
	.rides-cs {
		font-size: 12px;
		background: #009688;
		position: fixed;
		top: 340px;
		right: 0px;
		_position: absolute;
		z-index: 1500;
		border-radius: 6px 0px 0 6px;
	}
	
	.rides-cs a {
		color: #00A0E9;
	}
	
	.rides-cs a:hover {
		color: #ff8100;
		text-decoration: none;
	}
	
	.rides-cs .floatL {
		width: 36px;
		float: left;
		position: relative;
		z-index: 1;
		margin-top: 21px;
		height: 181px;
	}
	
	.rides-cs .floatL a {
		font-size: 0;
		text-indent: -999em;
		display: block;
	}
	
	.rides-cs .floatR {
		width: 130px;
		float: left;
		padding: 5px;
		overflow: hidden;
	}
	
	.rides-cs .floatR .cn {
		background: #F7F7F7;
		border-radius: 6px;
		margin-top: 4px;
	}
	
	.rides-cs .cn .titZx {
		font-size: 14px;
		color: #333;
		font-weight: 600;
		line-height: 24px;
		padding: 5px;
		text-align: center;
	}
	
	.rides-cs .cn ul {
		padding: 0px;
	}
	
	.rides-cs .cn ul li {
		display: flex;
		line-height: 38px;
		height: 38px;
		border-bottom: solid 1px #E6E4E4;
		overflow: hidden;
		text-align: center;      
	}
	
	.rides-cs .cn ul li span {
	   padding: 0 4px;
	/*   width: 60px;*/
		color: #777;
	}
	
	.rides-cs .cn ul li a {
		color: #777;
		padding: 0 2px;
       margin-top: 7px;
	}
	
	.rides-cs .cn ul li img {
		height: 22px;
		vertical-align: middle;
	}
	
	.rides-cs .btnOpen,
	.rides-cs .btnCtn {
		position: relative;
		z-index: 9;
		top: 25px;
		left: 0;
		background-image: url('../assets/img/source/lanrenzhijia.png');
		background-repeat: no-repeat;
		display: block;
		height: 146px;
		padding: 8px;
	}
	
	.rides-cs .btnOpen {
		background-position: 0 0;
	}
	
	.rides-cs .btnCtn {
		background-position: -37px 0;
	}
	
	.rides-cs ul li.top {
		border-bottom: solid #ACE5F9 1px;
	}
	
	.rides-cs ul li.bot {
		border-bottom: none;
	}
</style>


// WEBPACK FOOTER //
// src/components/qq-online.vue